import { PaymentsTerminalApi } from '@frontend/api-payments-terminal';
import { DiscoverReaderProp } from '../terminal-strategy';

export type ReaderWithLocationID = PaymentsTerminalApi.ReaderInfo & { locationId: string };
/**
 * Gets a list of readers from Weave's backend. Supports both dev and prod environments simultaneously.
 */
export const discoverReaders = async (readerLocations: DiscoverReaderProp[]) => {
  const result = await PaymentsTerminalApi.getTerminals(readerLocations.map((location) => location.locationId));

  const locationReaders =
    result.locationTerminalReadersInfo?.reduce((acc, reader) => {
      if (!reader || !reader.terminalReadersInfo.length) return acc;

      const locationId = reader.locationId;
      const readerInfo = reader.terminalReadersInfo.map((reader) => ({ ...reader, locationId }));

      return [...acc, ...readerInfo];
    }, [] as ReaderWithLocationID[]) ?? ([] as ReaderWithLocationID[]);

  return locationReaders;
};
